import { gql } from '@apollo/client'

export const storyFindMany = gql`
  query StoryFindMany($storySet: String!) {
    storyFindMany(filter: { storySet: $storySet }) {
      _id
    }
  }
`
